import { render, staticRenderFns } from "./PerPageSelector.vue?vue&type=template&id=2de08e82&"
import script from "./PerPageSelector.vue?vue&type=script&lang=js&"
export * from "./PerPageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports